import Button from "@/components/Button";
import styles from "./ReviewClientTasksTaskActionsRow.module.scss";

type ReviewClientTasksAddTaskControlsProps = {
  isSimplifyAllRemainingButtonVisible: boolean;
  isReviewLocked: boolean;
  isBulkSimplifyJobBusy: boolean;
  isSimplifyAllBulkActionsDisabled: boolean;
  bulkSimplifyLoadingSource:
    | "emptySimplified"
    | "emptyVerbatim"
    | "remaining"
    | null;
  onAddTask: () => void;
  onCreateSimplifiedRemaining: () => void;
};

export default function ReviewClientTasksAddTaskControls(
  props: ReviewClientTasksAddTaskControlsProps,
) {
  if (props.isSimplifyAllRemainingButtonVisible) {
    return (
      <div className={styles.taskActionsRow}>
        <Button
          data-testid="add-task-button"
          variant="outline"
          size="sm"
          disabled={props.isReviewLocked || props.isBulkSimplifyJobBusy}
          onClick={props.onAddTask}
        >
          + Add Task
        </Button>
        <Button
          data-testid="create-simplified-tasks-remaining-button"
          variant="outline"
          size="sm"
          type="button"
          loading={
            props.isBulkSimplifyJobBusy &&
            props.bulkSimplifyLoadingSource === "remaining"
          }
          disabled={props.isSimplifyAllBulkActionsDisabled}
          onClick={props.onCreateSimplifiedRemaining}
        >
          Create Simplified Tasks for All Remaining
        </Button>
      </div>
    );
  }
  return (
    <Button
      data-testid="add-task-button"
      variant="outline"
      size="sm"
      disabled={props.isReviewLocked || props.isBulkSimplifyJobBusy}
      onClick={props.onAddTask}
    >
      + Add Task
    </Button>
  );
}
